import { EqlFieldByID } from '@modules/queryBuilder/hooks/useFetchEQLReferences';
import { EqlFieldValue } from 'generated/graphql';

export const getHumanReadableEQLString = (
  eql: string,
  eqlFieldByFieldID: EqlFieldByID,
) => {
  const eqlFieldValuesByID: Record<string, EqlFieldValue> = {};
  Object.values(eqlFieldByFieldID).forEach((field) => {
    const eqlFieldValueByID = field?.eqlFieldValueByID;
    if (eqlFieldValueByID) {
      Object.keys(eqlFieldValueByID).forEach((innerKey) => {
        const eqlField = eqlFieldValueByID[innerKey];
        if (eqlField) {
          eqlFieldValuesByID[innerKey] = eqlField;
        }
      });
    }
  });

  // Replace field value UUIDs wrapped around single quotes with
  // their display name
  return eql.replace(/'([^']*)'/g, (_, value) => {
    const eqlField = eqlFieldValuesByID[value];
    if (eqlField) {
      return eqlField.displayName;
    }
    return value;
  });
};
